/**
 * Phone Format Input Behavior
 * ============================================================================
 * Auto-formats phone inputs with .js-phone-format class:
 *   - On page load: displays formatted phone (XXX) XXX-XXXX
 *   - On focus: switches to raw digits for editing
 *   - On blur: re-formats for display
 *   - On form submit: ensures raw digits are sent to server
 *
 * Dependencies: None (standalone, no external modules required)
 * ============================================================================
 */
(function () {
    'use strict';

    // ── Formatting helpers ──────────────────────────────────────────────

    /** Strip all non-digit characters */
    function toDigits(phone) {
        if (!phone) return '';
        return phone.replace(/\D/g, '');
    }

    /** Format digits for display: (XXX) XXX-XXXX */
    function formatForDisplay(phone) {
        var digits = toDigits(phone);
        if (!digits) return '';

        // 11 digits with leading 1 = US country code — strip it
        if (digits.length === 11 && digits[0] === '1') {
            digits = digits.slice(1);
        }

        if (digits.length === 10) {
            return '(' + digits.slice(0, 3) + ') ' + digits.slice(3, 6) + '-' + digits.slice(6);
        }

        // Non-standard length: return as-is
        return phone;
    }

    // ── Input behavior ──────────────────────────────────────────────────

    function initPhoneInput(input) {
        // Store raw value for form submission
        var rawValue = input.value || '';

        // Format on initial load
        var formatted = formatForDisplay(rawValue);
        if (formatted && formatted !== rawValue) {
            input.value = formatted;
        }

        // Focus: switch to raw digits for editing
        input.addEventListener('focus', function () {
            var digits = toDigits(input.value);
            if (digits) {
                // For 11-digit with leading 1 (E.164 without +), keep just 10
                if (digits.length === 11 && digits[0] === '1') {
                    digits = digits.slice(1);
                }
                input.value = digits;
            }
        });

        // Blur: re-format for display
        input.addEventListener('blur', function () {
            var formatted = formatForDisplay(input.value);
            if (formatted) {
                input.value = formatted;
            }
        });
    }

    /** Ensure raw digits are submitted (not formatted text) */
    function handleFormSubmit(form) {
        var inputs = form.querySelectorAll('.js-phone-format');
        for (var i = 0; i < inputs.length; i++) {
            var digits = toDigits(inputs[i].value);
            inputs[i].value = digits;
        }
    }

    // ── Initialization ──────────────────────────────────────────────────

    function init() {
        var inputs = document.querySelectorAll('.js-phone-format');
        var forms = new Set();

        for (var i = 0; i < inputs.length; i++) {
            initPhoneInput(inputs[i]);

            // Track parent forms for submit handling
            var form = inputs[i].closest('form');
            if (form) {
                forms.add(form);
            }
        }

        // Attach submit handler to each form (once per form)
        forms.forEach(function (form) {
            form.addEventListener('submit', function () {
                handleFormSubmit(form);
            }, { capture: true });
        });
    }

    // Run on DOMContentLoaded
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
